import { Checkbox, DropDownSelect, LabelWithRequired } from '@motili/ui';
import { useEffect, useState } from 'react';

import { setPartsEquipmentOrdering } from '../../../common/redux/ducks/contractorRegistrationForm';
import { useAppDispatch, useAppSelector } from '../../../common/redux/hooks';
import { DropdownOption } from '../../../common/types';
import { getDirectSupplyClients } from '../../../common/services/directSupplyClients';

import styles from './PartsEquipmentOrdering.module.scss';
import { PARTS_EQUIPMENT_ORDERING_OPTIONS } from '../../../common/constants';

const PartsEquipmentOrdering = () => {
    const dispatch = useAppDispatch();
    const partsEquipmentOrdering = useAppSelector(
        ({ contractorRegistration }) =>
            contractorRegistration.contractor.partsEquipmentOrdering
    );
    const { forMyCompany, onBehalfOfClient, neither, clients } =
        partsEquipmentOrdering;

    const [clientOptions, setClientOptions] = useState<DropdownOption[]>([]);

    const toggleCompanyOption =
        (option: PARTS_EQUIPMENT_ORDERING_OPTIONS) => (checked: boolean) => {
            dispatch(
                setPartsEquipmentOrdering({
                    ...partsEquipmentOrdering,
                    [option]: checked,
                    neither: false,
                    ...(option ===
                        PARTS_EQUIPMENT_ORDERING_OPTIONS.ON_BEHALF_OF_CLIENT &&
                    !checked
                        ? { clients: [] }
                        : {}),
                })
            );
        };

    const toggleNeither = (checked: boolean) => {
        dispatch(
            setPartsEquipmentOrdering({
                forMyCompany: false,
                onBehalfOfClient: false,
                neither: checked,
                clients: [],
            })
        );
    };

    const handleClientsChange = (selected: DropdownOption[]) => {
        dispatch(
            setPartsEquipmentOrdering({
                ...partsEquipmentOrdering,
                clients: selected ?? [],
            })
        );
    };

    useEffect(() => {
        const fetchDirectSupplyClients = async () => {
            if (!onBehalfOfClient) return;
            try {
                const directSupplyClients = await getDirectSupplyClients();
                setClientOptions(directSupplyClients);
            } catch (error) {
                alert(error);
            }
        };
        fetchDirectSupplyClients();
    }, [onBehalfOfClient]);

    return (
        <>
            <LabelWithRequired
                required
                label='I PLAN TO ORDER PARTS & EQUIPMENT FROM MOTILI FOR'
                style={{ marginTop: '20px' }}
            />
            <Checkbox
                className={styles.checkbox}
                id='parts-ordering-my-company'
                name={PARTS_EQUIPMENT_ORDERING_OPTIONS.FOR_MY_COMPANY}
                label='My Company'
                ariaLabel='My Company'
                value={PARTS_EQUIPMENT_ORDERING_OPTIONS.FOR_MY_COMPANY}
                checked={forMyCompany}
                disabled={neither}
                onChange={event =>
                    toggleCompanyOption(
                        PARTS_EQUIPMENT_ORDERING_OPTIONS.FOR_MY_COMPANY
                    )(event.target.checked)
                }
            />
            <Checkbox
                className={styles.checkbox}
                id='parts-ordering-on-behalf-of-client'
                name={PARTS_EQUIPMENT_ORDERING_OPTIONS.ON_BEHALF_OF_CLIENT}
                label='On behalf of Client'
                ariaLabel='On behalf of Client'
                value={PARTS_EQUIPMENT_ORDERING_OPTIONS.ON_BEHALF_OF_CLIENT}
                checked={onBehalfOfClient}
                disabled={neither}
                onChange={event =>
                    toggleCompanyOption(
                        PARTS_EQUIPMENT_ORDERING_OPTIONS.ON_BEHALF_OF_CLIENT
                    )(event.target.checked)
                }
            />
            {onBehalfOfClient ? (
                <div className={styles.clientDropdown}>
                    <DropDownSelect
                        isMulti
                        required
                        name='directSupplyClients'
                        placeholder='Select Client...'
                        options={clientOptions}
                        value={clients}
                        onChange={option =>
                            handleClientsChange(option as DropdownOption[])
                        }
                        className={styles.clientDropdown}
                    />
                </div>
            ) : null}
            <Checkbox
                className={styles.checkbox}
                id='parts-ordering-neither'
                name='neither'
                label='Neither'
                ariaLabel='Neither'
                value='neither'
                checked={neither}
                onChange={event => toggleNeither(event.target.checked)}
            />
        </>
    );
};

export default PartsEquipmentOrdering;
